import Button from '@zenbusiness/zui/Button';
import PropTypes from 'prop-types';

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import { MobileStepperStyled } from './CarouselStep.styles';

const CarouselStep = ({ activeStep, handleBack, handleNext, maxSteps }) => (
  <MobileStepperStyled
    activeStep={activeStep}
    backButton={
      <Button
        icon={<KeyboardArrowLeft />}
        onClick={handleBack}
        size="small"
        variant="text"
      />
    }
    nextButton={
      <Button
        icon={<KeyboardArrowRight />}
        onClick={handleNext}
        size="small"
        variant="text"
      />
    }
    position="static"
    steps={maxSteps}
    variant="dots"
  />
);

CarouselStep.propTypes = {
  /**
   * The active step (zero-based index) of the component.
   */
  activeStep: PropTypes.number.isRequired,
  /**
   * Function called when the back button is clicked.
   */
  handleBack: PropTypes.func.isRequired,
  /**
   * Function called when the next button is clicked.
   */
  handleNext: PropTypes.func.isRequired,
  /**
   * The total steps.
   */
  maxSteps: PropTypes.number.isRequired
};

export default CarouselStep;
